import React from 'react';
import { ICartDiscountModel } from '../../../models/stores/sub-stores/Cart';
import UtilityService from '../../../services/UtilityService';
import TrashCan from '../../content/TrashCan';

export const AppliedDiscountTestId = 'applieddiscount-summary';
export const AppliedDiscountRemoveButtonTestId =
  'applieddiscount-removebutton-summary';

export type AppliedDiscountProps = {
  discount: ICartDiscountModel;
  currencySymbol: string;
  onDiscountRemoveClicked: (discountToRemove: ICartDiscountModel) => void;
};

const AppliedDiscount: React.FC<AppliedDiscountProps> = ({
  discount,
  currencySymbol,
  onDiscountRemoveClicked,
}: AppliedDiscountProps) => {
  return (
    <tr className="container border-0" data-testid={AppliedDiscountTestId}>
      <td className="w-10/12 font-bold text-left line-clamp-1 hover:line-clamp-none mb-2 pl-0 md:pl-2">
        {discount.couponCode || discount.name}
      </td>
      <td className="text-right mb-2 pr-6 md:pr-4">
        {discount.couponCode && (
          <button
            type="button"
            data-testid={AppliedDiscountRemoveButtonTestId}
            onClick={() => onDiscountRemoveClicked(discount)}
          >
            <TrashCan />
          </button>
        )}
      </td>
      <td className="w-2/12 text-right mb-2 pr-2 md:pr-3">
        {UtilityService.formatAmount(discount.value, currencySymbol)}
      </td>
    </tr>
  );
};

export default AppliedDiscount;
